import React from 'react';

const Header = () => {
  return (
    <header className="App-header">
      <div id="header-title">
        <h1>
          <a href="https://spacewx.com/">
            <img
              src="https://spacewx.com/wp-content/uploads/2022/08/logo.png"
              alt="logo"
              style={{ width: '100%', height: 'auto' }}
            />
          </a>
        </h1>
      </div>
    </header>
  );
};

export default Header;